import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=3acee424&"
import script from "../../../services/applicant/home/privacy-policy.js?vue&type=script&lang=js&"
export * from "../../../services/applicant/home/privacy-policy.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports